// The authentication routes, in one place: the route guard returns the login
// path and several call sites compare against it, so a literal in each would
// silently break the comparisons the day one of them changes.

export const AUTHENTICATION_PATH_PREFIX = '/authentication';

export const LOGIN_PATH = `${AUTHENTICATION_PATH_PREFIX}/login`;

/**
 * React Router matches routes case-insensitively, so a case-variant URL like
 * `/Authentication/login` renders the same page — compare likewise. Prefixes
 * are expected in lowercase.
 */
export function hasPathPrefix(pathname: string, prefix: string): boolean {
  const normalizedPathname = pathname.toLowerCase();

  return (
    normalizedPathname === prefix || normalizedPathname.startsWith(`${prefix}/`)
  );
}

/** True for the login page and its siblings (callback, password change, …). */
export function isAuthenticationPath(pathname: string): boolean {
  return hasPathPrefix(pathname, AUTHENTICATION_PATH_PREFIX);
}
